import React from "react";

const Recommendation = () => {
  return (
    <div className="recommend">
      <div className="number">
        <span>#1</span>
      </div>
      <div className="recommend-description">
        <div className="title">Modern Wellness Brand. Effective, Clean, Science-Backed.</div>
        <div className="description">For Enthusiasts, by Connoisseurs.</div>
      </div>
    </div>
  );
};

export default Recommendation;
